import { render, staticRenderFns } from "./departmentTree.vue?vue&type=template&id=495308fe&scoped=true"
import script from "./departmentTree.vue?vue&type=script&lang=js"
export * from "./departmentTree.vue?vue&type=script&lang=js"
import style0 from "./departmentTree.vue?vue&type=style&index=0&id=495308fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@5.2.7_webpack@4.47.0___bc0963b6aefcdd755d0d0b687a7bc856/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495308fe",
  null
  
)

export default component.exports